'use client'

import dynamic from 'next/dynamic'

export const ModalClient = dynamic(() => import('./Modal').then(({ Modal }) => Modal), {
	ssr: false
})
